import * as React from 'react';
import { Outlet } from "react-router-dom";
import Container from '@mui/material/Container';

const Users = () => {
    return <Container component="main" maxWidth="xs">
            <h1>Users</h1>
            <Outlet />
        </Container>
};

export default Users;